import {
  PostIntegranteResolucion,
  GetIntegranteCargosByFolio,
  GetIntegrantesEliminados,
  GetAltasEnMembresiasExistentes,
  PutReasignarCargoIntegrante,
  State as ComisionMembresiaState
} from "../../../reducers/comisionMembresia";

export interface IntegranteResolucionStore
  extends PostIntegranteResolucion,
    GetIntegranteCargosByFolio,
    GetIntegrantesEliminados,
    GetAltasEnMembresiasExistentes,
    PutReasignarCargoIntegrante {}

export const integranteResolucionStore: (
  state
) => IntegranteResolucionStore = state => {
  const comisionMembresia: ComisionMembresiaState = state.comisionMembresia;

  return {
    // Post resolución
    postIntegranteResolucionResult:
      comisionMembresia.postIntegranteResolucionResult,
    postingIntegranteResolucion: comisionMembresia.postingIntegranteResolucion,
    postingIntegranteResolucionError:
      comisionMembresia.postingIntegranteResolucionError,

    // Get cargos by folio factura
    integranteCargosByFolio: comisionMembresia.integranteCargosByFolio,
    gettingIntegranteCargosByFolio:
      comisionMembresia.gettingIntegranteCargosByFolio,
    gettingIntegranteCargosByFolioError:
      comisionMembresia.gettingIntegranteCargosByFolioError,

    // Get integrantes eliminados
    integrantesEliminados: comisionMembresia.integrantesEliminados,
    gettingIntegrantesEliminados:
      comisionMembresia.gettingIntegrantesEliminados,
    gettingIntegrantesEliminadosError:
      comisionMembresia.gettingIntegrantesEliminadosError,

    // Get altas en membresías existentes
    altasEnMembresiasExistentes: comisionMembresia.altasEnMembresiasExistentes,
    gettingAltasEnMembresiasExistentes:
      comisionMembresia.gettingAltasEnMembresiasExistentes,
    gettingAltasEnMembresiasExistentesError:
      comisionMembresia.gettingAltasEnMembresiasExistentesError,

    // Put reasignar cargo
    putReasignarCargoIntegranteResult:
      comisionMembresia.putReasignarCargoIntegranteResult,
    puttingReasignarCargoIntegrante:
      comisionMembresia.puttingReasignarCargoIntegrante,
    puttingReasignarCargoIntegranteError:
      comisionMembresia.puttingReasignarCargoIntegranteError
  };
};
